<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="">
          <el-form-item label="签收时间:" class="item2">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width:420px"
              v-model="actualSignings"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算客户:">
            <el-input v-model="searchFrom.payee" placeholder="请输入结算客户"></el-input>
          </el-form-item>
          <el-form-item label="业务部门:"  >
            <el-select v-model="searchFrom.businessUnit" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="margin-left: 10px;">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">统计</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" :disabled="isDisable" @click="daochuFN">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref" @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%" class="tableComent" @selection-change='selectGoods'>
        <!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="payee" label="结算客户" width="320" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
        </el-table-column>
         <el-table-column prop="businessUnit" label="业务部门" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="cqJe" label="超期" width="150" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
             <el-button  type="text" v-if="scope.row.cqJe>0" @click="cqjedsFn(scope.row)" style="color: red;">{{scope.row.cqDs}}/{{scope.row.cqJe}}</el-button>
            <el-button  v-else  type="text" @click="cqjedsFn(scope.row)">{{scope.row.cqDs}}/{{scope.row.cqJe}}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="cqDs" label="超期单数" width="150" :formatter="formatterRowEmpty"></el-table-column> -->
        <el-table-column prop="" label="未开票未收款" width="150" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="wkpWskFn(scope.row)">{{scope.row.wkpWsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="未开票已收款" width="150" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="wkpYskFn(scope.row)">{{scope.row.wkpYsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="已开票未收款" width="150" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="ykpWskFn(scope.row)">{{scope.row.ykpWsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="已开票已收款" width="150" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="ykpYskFn(scope.row)">{{scope.row.ykpYsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="部分开票未收款" width="180" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="bfkpWskFn(scope.row)">{{scope.row.bfkpWsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="部分开票部分收款" width="180" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="bfkpBfskFn(scope.row)">{{scope.row.bfkpBfsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="部分开票已收款" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="bfkpYskFn(scope.row)">{{scope.row.bfkpYsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="未开票部分收款" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="wkpBfskFn(scope.row)">{{scope.row.wkpBfsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="已开票部分收款" width="160" :formatter="formatterRowEmpty">
          <template slot-scope="scope">
            <el-button type="text" @click="ykpBfskFn(scope.row)">{{scope.row.ykpBfsk}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="bkpBsk" label="不开票不收款" width="150" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getReportStatisticsYsList } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      actualSignings: [],
      searchFrom: {
        payeeType: '1',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      tableList: [],
      isDisable: false,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime()
          if (maxDate) {
            this.pickerMinDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const day30 = 30 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day30
            if (maxTime > new Date()) {
              maxTime = new Date()
            }
            return time.getTime() > maxTime
          }
          return time.getTime() > Date.now()
        }
      },
      bumenList: []
    }
  },
  created () {
    this.actualSignings = getLastMonth()
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 166 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.actualSignings && this.actualSignings.length > 0) {
        this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
        this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      } else {
        this.searchFrom.actualSigningTimeStart = null
        this.searchFrom.actualSigningTimeEnd = null
      }

      getReportStatisticsYsList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 选择数据
    selectGoods (selection) {
      // console.log(selection,'selection')
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payeeType: '1',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.actualSignings = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 导出
    daochuFN () {
      if (this.actualSignings && this.actualSignings.length > 0) {
        this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
        this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      } else {
        this.searchFrom.actualSigningTimeStart = null
        this.searchFrom.actualSigningTimeEnd = null
      }
      delete this.searchFrom.pageNo
      delete this.searchFrom.pageSize
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportReportStatisticsYsExcel',
        this.searchFrom,
        '应收跟踪列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 超期金额超期单数
    cqjedsFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, actualSignings: this.actualSignings, businessUnit: row.businessUnit, periodDate: new Date().getTime() } })
    },
    // 未开票未收款
    wkpWskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '0', ysInvoicingStates: '0', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 未开票已收款
    wkpYskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '2', ysInvoicingStates: '0', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 已开票未收款
    ykpWskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '0', ysInvoicingStates: '2', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 已开票已收款
    ykpYskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '2', ysInvoicingStates: '2', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 部分开票未收款
    bfkpWskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '0', ysInvoicingStates: '1', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 部分开票部分收款
    bfkpBfskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '1', ysInvoicingStates: '1', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 部分开票已收款
    bfkpYskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '2', ysInvoicingStates: '1', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 未开票部分收款
    wkpBfskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '1', ysInvoicingStates: '0', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    },
    // 已开票部分收款
    ykpBfskFn (row) {
      this.$router.push({ name: 'yingShouSettlement', query: { payee: row.payee, ysSettlementStates: '1', ysInvoicingStates: '2', actualSignings: this.actualSignings, businessUnit: row.businessUnit } })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
